const { isArray, isObject } = require('@/functions/is');
const { toCamelCase, toSnakeCase } = require('@/functions/strings');

/**
 * Returns a string from the given object by passing in a key like "section.KEY"
 *
 * @param  {object} obj Object containing the strings
 * @param  {string} key Name of the string to return
 * @return {*}     The element from the object
 */
const getPropertyByDotNotation = (obj, key) => {
    let arr = key.split('.');
    // eslint-disable-next-line no-cond-assign,no-empty
    while (arr.length && (obj = obj[arr.shift()])) {
    }

    return obj;
};

/**
 * Remove entries from the given object that are just empty strings, null, or empty arrays.
 * Modifies the original object.
 *
 * @param {*} obj
 *
 * @return {*} Returns the object for easier use.
 */
const removeEmptyValues = (obj) => {
    Object.keys(obj).forEach((key) => {
        let value = obj[key];
        // This is not as simple as !value because zero could be a valid value.
        if (
            value === null
            || value === undefined
            || value === ''
            || (typeof value === 'string' && value.trim() === '')
            || (value instanceof Array && value.length < 1)
        ) {
            delete obj[key];
        }
    });

    return obj;
};

/**
 * Set the properties given in data on the entity if those keys exist on the entity.
 * This is designed to make testing easier so we can pass data to the constructor of a model rather than manually
 * setting lots of properties or having to use a hydrator.
 *
 * @param {object} entity
 * @param {object} data
 */
const populate = (entity, data) => {
    if (!data) {
        return;
    }

    Object.keys(data).forEach((key) => {
        if (entity.hasOwnProperty(key)) {
            entity[key] = data[key];
        }
    });
};

const objectHasOwnPropertyOrSetter = (obj, propName) => {
    if (obj.hasOwnProperty(propName)) {
        return true;
    }

    let descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(obj), propName);
    return !!(descriptor && descriptor.set);
};

const convertKeysToCamelCase = (obj) => {
    const result = {};

    // Return primitive types as-is.
    if (typeof obj !== 'object') {
        return obj;
    }

    for (const key in obj) {
        /* istanbul ignore else */
        if (obj.hasOwnProperty(key)) {
            if (isArray(obj[key])) {
                result[toCamelCase(key)] = obj[key].map((value) => convertKeysToCamelCase(value));
            } else if (isObject(obj[key])) {
                result[toCamelCase(key)] = convertKeysToCamelCase(obj[key]);
            } else {
                result[toCamelCase(key)] = obj[key];
            }
        }
    }

    return result;
};

const convertKeysToSnakeCase = (obj) => {
    const result = {};

    for (const key in obj) {
        // Special case: keep ID as lowercase id:
        if (['ID'].includes(key)) {
            result[key.toLowerCase()] = obj[key];
        } else {
            result[toSnakeCase(key)] = obj[key];
        }
    }

    return result;
};

module.exports = {
    convertKeysToCamelCase,
    convertKeysToSnakeCase,
    getPropertyByDotNotation,
    objectHasOwnPropertyOrSetter,
    populate,
    removeEmptyValues,
};
